import React from "react";
import { Helmet } from "react-helmet";

function ErrorPage() {
  return (
    <div>
      <Helmet>
        <title>Error</title>
      </Helmet>
      ErrorPage
    </div>
  );
}

export default ErrorPage;
